<div class="modals" [ngClass]="{ 'solid-overlay': solidOverlay }" data-crlat="dialog">
    <ng-template [oxygen-dialog-container]></ng-template>
</div>
